import { useCallback, useEffect, useMemo, useState } from "react"
import { useSelector } from "react-redux"

import Countdown from "~/components/Countdown/Countdown"

import { formattedDuration } from "~/utils/TimeFormatter"
import Button from "~/components/Button/Button"

import "./Timer.scss"
import { LuxaforColor, setLuxaforLight } from "../../utils/Luxafor"
import { getUser } from "~/store"
import { BREAK_MESSAGES } from "./breakMessages"
import {
  animateTimerFaviconIn,
  setCycleFavicon,
  setTimerFavicon,
} from "../../utils/Favicon"
import { Timer as TimerType } from "~/types"

type TimerProps = {
  timer: TimerType
  onEnded: () => void
  onCancel: () => void
}

function Timer(props: TimerProps) {
  const user = useSelector(getUser)
  const { timer, onEnded, onCancel } = props
  const [isAnimatedIn, setIsAnimatedIn] = useState(false)

  const updateTitleAndFavicon = useCallback(
    (durationLeft?: number) => {
      if (!durationLeft) {
        document.title = "Pomodoro"
        setCycleFavicon(timer.break ? "break" : "work")
      } else {
        if (isAnimatedIn) setTimerFavicon(timer)
        document.title = formattedDuration(durationLeft)
      }
    },
    [isAnimatedIn],
  )

  useEffect(() => {
    if (!user) return

    setLuxaforLight(user, timer.break ? LuxaforColor.GREEN : LuxaforColor.RED)
    animateTimerFaviconIn(timer, 3000).then(() => setIsAnimatedIn(true))

    return () => {
      setLuxaforLight(user, LuxaforColor.OFF)
      updateTitleAndFavicon()
    }
  }, [setIsAnimatedIn])

  const stringText = useMemo(() => {
    return BREAK_MESSAGES[Math.floor(Math.random() * BREAK_MESSAGES.length)]
  }, [])

  const handleCancel = () => {
    updateTitleAndFavicon()
    onCancel()
  }

  return (
    <div className="Timer">
      <span className="Timer__headline">
        {timer.break ? stringText : "Stay focused for"}
      </span>

      <div className="Timer__countdown">
        <Countdown
          onTick={updateTitleAndFavicon}
          timer={timer}
          onEnded={onEnded}
        />
      </div>
      <Button
        text="Stop timer"
        className={`Timer__cycle--${timer.break ? "break" : "work"}`}
        style={"outline"}
        onClick={handleCancel}
      />
    </div>
  )
}

export default Timer
